<template>
  <section>
    <form-wizard
      ref="wizard"
      color="#FFBB44"
      :title="null"
      :subtitle="null"
      finish-button-text="Submit"
      back-button-text="Previous"
      class="steps-transparent mb-3"
      @on-complete="formSubmitted"
    >
      <tab-content
        title="Basic Information"
        :before-change="validationFormBasicInformation"
      >
        <validation-observer ref="basicInformation" tag="form">
          <basic-information
            class="py-2"
            @getCompetition="getCompetition"
            :competition="competition"
            @basicInformation="
              newCompetition = { ...newCompetition, ...$event }
            "
            @validDate="validDate = $event"
          />
        </validation-observer>
      </tab-content>
      <tab-content
        title="Rules and conditions"
        :before-change="validationFormRulesAndConditions"
      >
        <validation-observer ref="rulesAndConditions" tag="form">
          <rules-and-conditions
            class="py-2"
            :competition="competition"
            @rulesAndConditions="
              newCompetition = { ...newCompetition, ...$event }
            "
          />
        </validation-observer>
      </tab-content>
      <tab-content
        title="Partner conditions"
        :before-change="validationFormPartnerConditions"
      >
        <validation-observer ref="partnerConditions" tag="form">
          <partner-conditions
            class="py-2"
            :competition="competition"
            @partnerConditions="
              newCompetition = { ...newCompetition, ...$event }
            "
          />
        </validation-observer>
      </tab-content>
      <tab-content
        title="Fees and awards"
        :before-change="validationFormFeesAndAwards"
      >
        <validation-observer ref="feesAndAwards" tag="form">
          <fees-and-awards
            class="py-2"
            :competition="competition"
            @handleWinners="handleWinners = $event"
            @feesAndAwards="newCompetition = { ...newCompetition, ...$event }"
          />
        </validation-observer>
      </tab-content>
      <tab-content title="Card preview">
        <validation-observer ref="cardPreview" tag="form">
          <card-preview
            class="py-2"
            :competition="newCompetition"
            :status="competition.verify_status"
            :image="
              $route.params.id
                ? competition.thumbnail
                : newCompetition.thumbnail
            "
          />
        </validation-observer>
      </tab-content>
    </form-wizard>
    <loader :loading="loading" />
  </section>
</template>
<!-- <validation-observer ref="courseForm" #default="{ invalid }">
      <b-form @submit.prevent>
        <h1 class="font-weight-bolder my-1">{{ title }}</h1>
        <b-row>
          <b-col
            ><basic-information /> <rules-and-conditions /> <card-preview
          /></b-col>
          <b-col
            ><fees-and-awards /> <partner-conditions /><competition-thumbnail
          /></b-col>
        </b-row>
      </b-form>
    </validation-observer> -->

<script>
import { BRow, BCol, BForm } from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import BasicInformation from "./BasicInformation.vue";
import FeesAndAwards from "./FeesAndAwards.vue";
import RulesAndConditions from "./RulesAndConditions.vue";
import PartnerConditions from "./PartnerConditions.vue";
import CardPreview from "./CardPreview.vue";
import Loader from "@/@core/components/loader/Loader.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

export default {
  components: {
    BRow,
    BCol,
    BForm,
    ValidationProvider,
    ValidationObserver,
    BasicInformation,
    FeesAndAwards,
    RulesAndConditions,
    PartnerConditions,
    CardPreview,
    FormWizard,
    TabContent,
    Loader,
  },

  data() {
    return {
      loading: false,
      competition: {},
      newCompetition: {},
      handleWinners: "",
      validDate: false,
    };
  },
  computed: {
    userData() {
      return this.$store.state.auth.userData;
    },
    title() {
      return this.$route.params.id ? "Edit competition" : "Create competition";
    },
  },

  async created() {
    if (this.$route.params.id) {
      await this.getCompetition();
      this.$refs.wizard.activateAll();
    }
  },
  methods: {
    async getCompetition() {
      this.loading = true;
      try {
        const { data } = await this.$http.get(
          `/panel/competitions/${this.$route.params.id}`,
          {
            params: {
              include: ["brokers"],
            },
          }
        );
        this.competition = data.data;
        this.remaining = this.calRemaining(this.competition);
        if (
          this.userData.type !== "admin" &&
          (this.remaining.status !== "yellow" || this.competition.paid_at)
        ) {
          this.$router.push({ name: "competitions" });
        }
      } catch (err) {}
      this.loading = false;
    },
    validationFormBasicInformation() {
      return new Promise((resolve, reject) => {
        this.$refs.basicInformation.validate().then((success) => {
          if (success && this.validDate) {
            resolve(true);
          } else {
            reject();
          }
        });
      });
    },
    validationFormRulesAndConditions() {
      return new Promise((resolve, reject) => {
        this.$refs.rulesAndConditions.validate().then((success) => {
          if (success) {
            resolve(true);
          } else {
            reject();
          }
        });
      });
    },
    validationFormPartnerConditions() {
      return new Promise((resolve, reject) => {
        this.$refs.partnerConditions.validate().then((success) => {
          if (success) {
            resolve(true);
          } else {
            reject();
          }
        });
      });
    },
    validationFormFeesAndAwards() {
      return new Promise((resolve, reject) => {
        this.$refs.feesAndAwards.validate().then((success) => {
          if (success && !this.handleWinners) {
            resolve(true);
          } else {
            reject();
          }
        });
      });
    },
    async formSubmitted() {
      this.loading = true;

      try {
        this.formData = await new FormData();
        let newCompetition = { ...this.newCompetition };
        await Object.keys(newCompetition).map((item) => {
          if (
            item == "registration_begin" ||
            item == "registration_end" ||
            item == "ended_at" ||
            item == "started_at"
          ) {
            newCompetition[item] = this.toUtc(newCompetition[item]);
          }
        });
        await Object.keys(newCompetition).map((item, index) => {
          this.setFormData(newCompetition[item], index, item);
        });

        if (this.$route.params.id) {
          const { data } = await this.$http.post(
            `panel/competitions/${this.$route.params.id}?_method=put`,
            this.formData
          );
          await this.getCompetition();
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Competition Updated",
              icon: "EditIcon",
              variant: "success",
            },
          });
        } else {
          const { data } = await this.$http.post(
            "panel/competitions",
            this.formData
          );
        }
        this.$router.push("/competitions").catch((err) => {});
      } catch (error) {}
      this.loading = false;
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
